/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import Loading from "../../../../Components/Interactive/Loading";
import BrandIcon from "../../../../Utilities/BrandIcon";

import { formatMoreInfoProperties } from "../../../../Helpers/formatters";

const MoreCustomerDetailsWidget = ({ allCustomerData, loading }) => {
  const {
    userDetailsInfo: { brandId, customerId },
  } = allCustomerData;
  return (
    <div className="user-data-container customer-details" style={{"height": "100%"}}>
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        brandId && <BrandIcon brandId={brandId} />
      )}
      {customerId && formatMoreInfoProperties(customerId)}
    </div>
  );
};

export default MoreCustomerDetailsWidget;
